import React, { useState } from "react";
import { Button, TextField, Typography, Grid, Divider } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useDispatch, useSelector } from "react-redux";
import DeleteIcon from '@mui/icons-material/Delete';
import {
    setState
} from "./editScenarioNewSlice";
import CloseIcon from "@mui/icons-material/Close";

const style = {
    position: "absolute",
    top: "20%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 450,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 2,
    borderRadius: 1,
};

export default function CloneConfirmationModal() {
    const dispatch = useDispatch();
    const setupState = useSelector((store) => store.editScenarioNew);
    const { openClonePopup } = setupState;

    function handleClose() {
        dispatch(setState("openClonePopup", false));
    }

    function cloneScenario() {
        dispatch(setState("openClonePopup", false));
        dispatch(setState("isCloneClicked", true));
    }

    return (
        <Box>
            <Modal open={openClonePopup} onClose={handleClose}>
                <Box sx={style}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        <Typography variant="subtitle2" sx={{ fontSize: '24px' }}>Confirmation</Typography>
                        <Button sx={{
                            "&:hover": {
                                bgcolor: "grey.lighter",
                            }, minWidth: "30px !important"
                        }}
                            startIcon={<CloseIcon sx={{ color: "black.main" }} />}
                            onClick={handleClose}
                        ></Button>
                    </Box>
                    <Divider sx={{ mt: 2 }} />
                    <br />
                    <Typography variant="subtitle3">Scenario will be cloned. Are you sure ?</Typography>
                    <br />
                    <Divider sx={{ mt: 2 }} />
                    <br />
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-end",
                        }}
                    >
                        <Button
                            sx={{
                                bgcolor: "darkred.light",
                                color: "white.main",
                                textTransform: "none",
                                fontWeight: "bold",
                                mt: 1,
                                mr: 2,
                                "&:hover": {
                                    bgcolor: "darkred.main",
                                    color: "white.main",
                                },
                            }}
                            onClick={handleClose}
                        >
                            No
                        </Button>
                        <Button
                            sx={{
                                bgcolor: "darkred.light",
                                color: "white.main",
                                textTransform: "none",
                                mt: 1,
                                "&:hover": {
                                    bgcolor: "darkred.main",
                                    color: "white.main",
                                },
                            }}
                            onClick={cloneScenario}
                        >
                            Yes
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </Box>
    );
}